module.exports = __webpack_public_path__ + "static/media/ombrenomade-removebg-preview.60a951c3.png";